module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_35.678c8738.png";